// @ts-check

/**
 * Takes a phone number with formatting (like from a mask),
 * such as (233) 234-2333, and returns just the numerals like 2232342333
 * in the phone number, which can be useful for storing in
 * redux, or submitting to API.
 *
 * @param {string?} value
 */
const normalizePhone = value => {
  if (!value) {
    return value;
  }

  return value.replace(/[^\d]/g, '');
};

export default normalizePhone;
